import { RichText } from 'prismic-reactjs';
import {
  GoalsImageWrapper,
  GoalsInner,
  GoalsPoint,
  GoalsPointCheckmark,
  GoalsTextWrapper,
  GoalsTitle,
  GoalsTitlePrimary,
  GoalsTitleWhite,
  Wrapper,
} from './businessGoals.styles';
import Image from 'next/image';
import { IBusinessProps } from './businessGoals.models';
import { imageSerializer } from '../../../utils/imageSerializer';

export const BusinessGoals = ({ data, titleAs }: IBusinessProps) => {
  return (
    <Wrapper>
      <GoalsInner>
        <GoalsTextWrapper>
          <GoalsTitle as={titleAs}>
            <GoalsTitlePrimary>{data.title}</GoalsTitlePrimary>
            <GoalsTitleWhite>{data.title2}</GoalsTitleWhite>
          </GoalsTitle>
          {data.points.map((point: any, index: number) => {
            return (
              <GoalsPoint key={index}>
                <GoalsPointCheckmark>
                  <svg
                    width="21"
                    height="16"
                    viewBox="0 0 21 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.588 2.52266L7.57807 16L0.383143 8.56185C0.130978 8.28171 -0.00630293 7.91119 0.000222409 7.52835C0.00674775 7.1455 0.15657 6.78022 0.418124 6.50947C0.679679 6.23872 1.03255 6.08362 1.40238 6.07687C1.77222 6.07011 2.13015 6.21222 2.40077 6.47326L7.57807 11.8228L18.5703 0.434072C18.7069 0.291552 18.8703 0.179551 19.0504 0.104991C19.2304 0.0304314 19.4233 -0.00510121 19.6172 0.000590008C19.9771 0.0100618 20.319 0.165775 20.5689 0.434072C20.7037 0.569298 20.8112 0.730873 20.8852 0.90943C20.9592 1.08799 20.9982 1.27997 20.9999 1.47425C21.0017 1.66853 20.9662 1.86125 20.8955 2.04121C20.8248 2.22118 20.7202 2.38483 20.588 2.52266Z"
                      fill="url(#paint0_linear_5506_27551)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_5506_27551"
                        x1="0"
                        y1="15.9994"
                        x2="19.6484"
                        y2="15.9994"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#0E4ED7" />
                        <stop offset="1" stopColor="#F94743" />
                      </linearGradient>
                    </defs>
                  </svg>
                </GoalsPointCheckmark>
                {RichText.asText(point.business_goal)}
              </GoalsPoint>
            );
          })}
        </GoalsTextWrapper>
        <GoalsImageWrapper>
          <Image
            {...imageSerializer(data.image, {
              inset: null,
            })}
          />
        </GoalsImageWrapper>
      </GoalsInner>
    </Wrapper>
  );
};
